<template>
  <div class="localidades container" v-bind:class="{ loading }">
    <custom-select
      label="Localidad"
      :value="value"
      name="localidad"
      @input="onChange"
      :items="localidades"
      @focus="$emit('focus')"
    />
  </div>
</template>

<script>
import CustomSelect from "@/components/core/custom/CustomSelect";
export default {
  name: "CityList",
  components: { CustomSelect },
  props: {
    value: String,
    province: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      localidades: [],
      loading: true
    };
  },
  watch: {
    province: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getLocalidades(newVal);
      }
    }
  },
  mounted() {
    if (this.province) {
      this.getLocalidades(this.province);
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
    },
    getLocalidades(province) {
      // Reset localidades
      this.localidades = [];
      this.loading = true;

      // Obtener localidades
      let _localidades = require(`@/config/constants/localidades/${province}.json`);
      if (_localidades) {
        // Formatear en formato que admite customselect y poner en mayúsculas
        this.localidades = _localidades.localidades.map(localidad => {
          return {
            value: localidad.toUpperCase(),
            label: localidad.toUpperCase()
          };
        });
        this.loading = false;
        // Mantener en sync los otros componentes
        // Al obtener las localidades se selecciona el primero
        this.$emit("input", this.localidades[0].value);
      }
    }
  }
};
</script>

<style scoped>
.loading {
  opacity: 0.6;
  cursor: wait;
  pointer-events: none;
}
</style>
